import i18next from 'i18next';

i18next.addResources('es_CL', 'CallCenterCheckout', {
  orderShoppingCart: 'Detalle de la orden',
  receiptNeeded: '¿Necesitas facturas?',
  paymentMethods: 'Métodos de pago',
  orderDetail: 'Resumen'
});
